






















import Vue from 'vue'
import { Profile2ElInterface } from '@/config/interfaces'
import DefaultProfilePic from '@/assets/profil.png'
export default Vue.extend({
  name: 'Profile2El',

  props: {
    templateItemData: {
      type: Object as () => Profile2ElInterface,
      required: true
    }
  },
  data: function () {
    return {
      defaultProfilePic: DefaultProfilePic
    }
  }
})
